import { BOOLEAN_FILTER_OPTIONS } from "../../table-filter/filter-types/boolean";
import { getFilterIndicator } from "../helpers";

import type { FilterStrategy } from "./types";

/**
 * "yes"/"no" alone match every boolean filter, so a result also matches on
 * the filter's label: "blacklist" offers "Scheduling Blacklist › Yes" and
 * "No", and "blacklist no" narrows to the one. Query words match the start
 * of a word, so typing stays incremental ("blackl") without "a" or "no"
 * matching inside unrelated words.
 */
const startsAWord = (words: string[], prefix: string) =>
  words.some((word) => word.startsWith(prefix));

export const booleanStrategy: FilterStrategy = {
  search(filterType, ctx, out) {
    const options = filterType.options?.length
      ? filterType.options
      : BOOLEAN_FILTER_OPTIONS;
    const words = ctx.query.split(/\s+/).filter(Boolean);
    const labelWords = filterType.label.toLowerCase().split(/\s+/);
    // A bare "yes" is ambiguous across filters; rank label matches first.
    const hitsLabel = words.some((word) => startsAWord(labelWords, word));
    for (const option of options) {
      const combined = [
        ...labelWords,
        ...option.label.toLowerCase().split(/\s+/),
      ];
      if (!words.every((word) => startsAWord(combined, word))) continue;
      out.push({
        filterKey: filterType.filterKey,
        filterLabel: filterType.label,
        optionValue: option.value,
        optionLabel: option.label,
        type: filterType.type,
        score: hitsLabel ? 85 : 60,
        indicator: getFilterIndicator(filterType),
      });
    }
  },
  isSelected(currentValue, optionValue) {
    return String(currentValue) === String(optionValue);
  },
  toggle(result, currentValue) {
    // Picking the active choice again clears the filter back to Any.
    return {
      value:
        String(currentValue) === String(result.optionValue)
          ? undefined
          : result.optionValue,
    };
  },
};
